import DeptTreeV2 from './src/main';

/* istanbul ignore next */
DeptTreeV2.install = function(Vue) {
  Vue.component(DeptTreeV2.name, DeptTreeV2);
};

export default DeptTreeV2;
